import { Badge, Text, Stack } from '@leroy-merlin-br/backyard-react-ui'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import { cheapestModalityOption } from 'catalog/utils/cheapest-modality-option'
import { workDaysText } from 'catalog/utils/shipments-dictionary'

const MainShipmentPrices = ({ modalities, isPickupEnabled }) => {
  const cheapest = cheapestModalityOption(modalities)
  const price = formatPriceToBRL(cheapest.cost)
  const message = workDaysText(cheapest.deadline)

  return (
    <Stack spacing="byte" align="center">
      {isPickupEnabled && (
        <Text as="span" noMargin>
          Retire na loja por{' '}
          <Badge isLight color="green">
            R$ 0,00
          </Badge>
        </Text>
      )}

      <Text as="span" noMargin>
        Receba {message.prefix}{' '}
        <Text as="strong" bold noMargin>
          {message.deadline}
        </Text>{' '}
        por{' '}
        <Text as="strong" bold noMargin>
          {price}
        </Text>
      </Text>
    </Stack>
  )
}

export default MainShipmentPrices
